import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateCarParkDataState,
	globalStateCarParkDataReducer,
	globalStateCarParkDataAction,
} from "./data";

export type StateCarPark = {
	data: globalStateCarParkDataState;
};

export const carPark = combineReducers<StateCarPark>({
	data: globalStateCarParkDataReducer,
});

export const globalStateCarParkAction = {
	data: globalStateCarParkDataAction,
};

export default carPark;
